/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-08-18 18:57:36
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-10-30 19:48:45
 * @FilePath: /Client/src/views/signup/components/utils.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ref, computed, Ref } from 'vue'
import { ElMessage as message } from 'element-plus'
import { t } from '@/plugins/i18n'
import cache from '@/plugins/cache'
import { countries } from '../const'
import { CountriesEnum } from '@/common/const'
import store from '@/store'
import { MobileCodeParams } from '@/apis/login'
/** 获取默认语言的code */
export const getDefaultContry = () => {
  const find = countries.find((item) =>
    item.navigatorLang.includes(store.getters.site || navigator.language)
  ) || {
    key: CountriesEnum.Japan,
    desc: '日本',
    navigatorLang: ['ja'],
    mobileAreaCode: '+81'
  }
  return find
}
/**
 * 获取验证码
 * @param record 记录
 * @param EmailApi 邮箱的请求接口
 * @param PhoneApi 手机请求验证码
 * @returns
 */
export const useGetCode = (record: string, EmailApi: any, PhoneApi: any = null): any => {
  const disabled = ref(true)
  const loading = ref(false)
  let timer: any = null
  const count = ref(0)

  const tick = () => {
    timer = setInterval(() => {
      count.value--
      if (count.value <= 0) {
        cache.delete(record)
        clearInterval(timer)
      }
    }, 1000)
  }

  const prev = cache.get(record)
  if (prev) {
    if (prev <= 0) {
      cache.get(record)
    } else {
      const value = 60 - Math.ceil((Date.now() - prev) / 1000)
      count.value = value <= 0 ? 0 : value
      count.value > 0 && tick()
    }
  }

  const startCount = () => {
    cache.set(record, Date.now())
    count.value = 60
    tick()
  }

  const getEmailCode = (customerEmail: string, api = EmailApi, ...rest: any[]): any => {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loading.value) {
          message.warning(t('已发送验证码请求，请勿重复发送请求'))
        } else if (disabled.value) {
          message.error(t('邮箱格式不正确，请重新输入'))
          resolve(false)
        } else {
          loading.value = true
          api(customerEmail, ...rest)
            .then((res: any) => {
              loading.value = false
              if (res.success) {
                message.success(t('验证码正在发送，请注意查收'))
                resolve(true)
                startCount()
              } else {
                resolve(false)
              }
            })
            .catch((err: Error): void => {
              loading.value = false
              console.log(err)
            })
        }
      })
    })
  }

  /** 获取手机号验证码 */
  const getPhoneCode = (params: MobileCodeParams, api = PhoneApi): Promise<boolean> => {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loading.value) {
          message.warning(t('已发送验证码请求，请勿重复发送请求'))
        } else if (disabled.value) {
          message.error(t('请重新输入正确的手机号'))
          resolve(false)
        } else {
          loading.value = true
          api(params)
            .then((res: any) => {
              loading.value = false
              if (res.success) {
                message.success(t('验证码正在发送，请注意查收'))
                resolve(true)
                startCount()
              } else {
                resolve(false)
              }
            })
            .catch((err: Error): void => {
              loading.value = false
              console.log(err)
            })
        }
      })
    })
  }

  const tip = computed(() => {
    return `${t('已发送')}(${count.value})`
  })
  return { count, tip, disabled, getCode: getEmailCode, getPhoneCode }
}

export const useLoading = <T, R>(
  api: (...rest: R[]) => Promise<T>
): [Ref, (...rest: R[]) => Promise<T>] => {
  const loading = ref(false)
  const wrap = async (...rest: R[]): Promise<T> => {
    loading.value = true
    const res = await api(...rest)
    loading.value = false
    return res
  }
  return [loading, wrap]
}
